import { render } from "./WindchillView.vue?vue&type=template&id=d2b9b416"
import script from "./WindchillView.vue?vue&type=script&lang=js"
export * from "./WindchillView.vue?vue&type=script&lang=js"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__